<div class="ws-identity">
  <span class="ws-identity__kicker">Workspace</span>

  @if (interactive()) {
    <button
      type="button"
      class="ws-identity__button"
      [attr.aria-expanded]="open()"
      [attr.title]="name()"
      (click)="toggle()"
      >
      <span class="ws-identity__name">{{ name() }}</span>
      <i class="ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i>
    </button>

    @if (open()) {
      <div class="ws-identity__panel">
        <p class="ws-identity__panel-title">Your workspaces</p>
        <ul>
          @for (workspace of workspaces(); track workspace.customer) {
            <li>
              <span>{{ workspace.title }}</span>
              @if (isActive(workspace)) { <span class="ws-identity__current">Current</span> }
            </li>
          }
        </ul>
        <p class="ws-identity__note">Switching the active workspace is not available yet.</p>
      </div>
    }
  } @else {
    <span class="ws-identity__name ws-identity__name--static" [attr.title]="name()">{{ name() }}</span>
  }
</div>
